/* eslint-disable jsx-a11y/click-events-have-key-events */
import cn from 'classnames';
import React, { HTMLProps, MouseEventHandler, RefObject, useRef } from 'react';
import { connect } from 'react-redux';
import { IRootState } from 'src/redux/rootReducer';
import { getRandomId } from 'src/utils';
import { isEmpty } from 'src/validations';
import { Icon } from '..';
import Element from '../Element';
import View from '../View';
import './styles.scss';

const Input: React.FC<InputProps> = ({
  children,
  errorMessage,
  label,
  className,
  containerClassName,
  inputRef = null,
  iconName = '',
  onIconClick,
  onControlClick,
  datalist,
  datalistName,
  dataToolTip,
  ...props
}) => {
  const id = useRef<string>(`input-${getRandomId()}`);
  const { type, value, step } = props;

  const onClickMinus = () => {
    if (typeof value === 'string' && typeof step === 'number') {
      let newValue = parseFloat(value) - step;
      if (newValue < 0.25) newValue = 0.25;
      onControlClick(newValue);
    }
  };

  const onClickPlus = () => {
    if (typeof value === 'string' && typeof step === 'number') {
      const newValue = value === 'null' ? step : parseFloat(value) + step;
      onControlClick(newValue);
    }
  };

  return (
    <Element
      data-tooltip={dataToolTip || null}
      id={id.current}
      errorMessage={errorMessage}
      label={label}
      className={cn(containerClassName, 'has-tooltip-multiline')}>
      <View className={type === 'number' && 'input-number-container'}>
        {type === 'number' && (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <span onClick={onClickMinus} className={cn('cmp-input__step-icon', 'cmp-input__step-icon--minus')}>
            &minus;
          </span>
        )}
        <input
          id={id.current}
          list={datalistName || null}
          className={cn(
            className,
            'cmp-input',
            {
              'cmp-input--error': !isEmpty(errorMessage),
            },
            {
              'cmp-input--icon': !isEmpty(iconName),
            },
          )}
          ref={inputRef}
          {...props}
        />
        {type === 'number' && (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <span onClick={onClickPlus} className={cn('cmp-input__step-icon', 'cmp-input__step-icon--plus')}>
            +
          </span>
        )}

        {datalist && (
          <datalist id={datalistName}>
            {datalist.map((value, index) => (
              <option key={index} value={value} />
            ))}
          </datalist>
        )}
        {iconName && <Icon name={iconName} className="cmp-input__icon" onClick={onIconClick} />}
      </View>
    </Element>
  );
};

type BaseInputProps = Pick<HTMLProps<HTMLInputElement>, Exclude<keyof HTMLProps<HTMLInputElement>, 'label'>>;
export type InputProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps &
  BaseInputProps & {
    errorMessage?: string;
    containerClassName?: string;
    inputRef?: RefObject<HTMLInputElement>;
    iconName?: string;
    onIconClick?: MouseEventHandler<HTMLElement>;
    label?: string | React.ReactNode;
    datalist?: string[];
    datalistName?: string;
    onControlClick?: (newValue) => void;
    dataToolTip?: string;
  };

const mapStateToProps = (state: IRootState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Input);
